import React from 'react';
import classnames from 'classnames';
export const ColorPicker = React.forwardRef(({ colors, value, disabled = false, readonly = false, tabIndex = 0, onChange, onFocus, onBlur, }, ref) => {
    const handleItemClick = (color) => () => {
        if (!disabled && !readonly && color !== value && onChange) {
            onChange(color);
        }
    };
    const handleKeyDown = (event) => {
        const keyCode = event.nativeEvent.code;
        if (!onChange) {
            return;
        }
        if (keyCode === 'ArrowLeft') {
            for (let i = 1; i < colors.length; i = i + 1) {
                if (colors[i] === value) {
                    onChange(colors[i - 1]);
                    return;
                }
            }
            onChange(colors[colors.length - 1]); // in case we haven't found current value, or it was leftmost, pick the rightmost one as next
        }
        if (keyCode === 'ArrowRight') {
            for (let i = colors.length - 2; i >= 0; i = i - 1) {
                if (colors[i] === value) {
                    onChange(colors[i + 1]);
                    return;
                }
            }
            onChange(colors[0]); // in case we haven't found current value, or it was rightmost, pick the leftmost one as next
        }
    };
    return (React.createElement("div", { className: classnames('ColorPicker', {
            'ColorPicker--disabled': disabled,
        }), tabIndex: !disabled && !readonly ? tabIndex : undefined, onKeyDown: handleKeyDown, onFocus: onFocus, onBlur: onBlur, ref: ref, "data-anvil-component": "ColorPicker" }, colors.map((color, index) => (React.createElement("button", { key: index, className: classnames('ColorPicker__Item', {
            'ColorPicker__Item--active': color === value,
        }), style: { backgroundColor: color }, onClick: handleItemClick(color), "aria-label": color })))));
});
//# sourceMappingURL=ColorPicker.js.map